import { useCallback, useState, type SetStateAction } from 'react';

type Dispatch<A extends any[]> = (...args: A) => void;

export function useStateTracked<S>(
  initialState: S | (() => S),
): [state: S, setState: Dispatch<[SetStateAction<S>, boolean | void]>, changed: boolean] {
  const [value, _setValue] = useState(initialState);
  const [changed, setChanged] = useState(false);

  const setValue = useCallback((value: SetStateAction<S>, resetChange: boolean | void) => {
    setChanged(!resetChange);
    _setValue(value);
  }, []);

  return [value, setValue, changed];
}
